/**
 * @description List of default settings panel tabs.
 */
export enum SettingsTab {
  SETTINGS = 'settings',
  STYLES = 'styles',
  DATA = 'data',
}
